export const P = ({ title, children }) => (
  <div>
    <h2 className="font-bold text-gray-900 text-lg mb-3 pl-4 border-l-4 border-[#f97316]">{title}</h2>
    <p className="text-gray-500 text-sm leading-relaxed">{children}</p>
  </div>
);